import { AgentTracePanel } from "@/components/studio-data/AgentTracePanel";
import { useHeaderRefresh } from "@/contexts/HeaderRefreshContext";

/** Renders the vision agent trace panel from header refresh context state (layout layer). */
export function AgentTracePanelHost() {
  const hr = useHeaderRefresh();
  if (!hr?.agentTraceOpen) return null;
  return (
    <AgentTracePanel
      key={hr.agentTracePanelKey}
      seedRunId={hr.agentTraceSeedId}
      onClose={hr.closeAgentTrace}
    />
  );
}
